import { Box, Table } from "@radix-ui/themes";
import clsx from "clsx";
import React from "react";

type DataTableProps = Omit<
  React.ComponentPropsWithoutRef<typeof Table.Root>,
  "children"
> & {
  children: [React.ReactNode, React.ReactNode];
  className?: string;
  zebra?: boolean;
  showLastDivider?: boolean;
  showFirstDivider?: boolean;
  mx?: string;
  bgHeader?: string;
};

export default function DataTable({
  children,
  className,
  zebra = false,
  mx = "-24px",
  bgHeader = "#F2F4F7",
  showLastDivider = false,
  showFirstDivider = false,
  ...props
}: DataTableProps) {
  const [headerCells, bodyRows] = children;

  return (
    <Box className={`mx-[${mx}]`}>
      <Table.Root
        style={{
          ["--table-cell-padding" as any]: "6px 24px",
          ["--tbl-last-divider" as any]: "#F2F4F7",
        }}
        className={clsx(
          "[&_.rt-TableCell]:[align-content:center]",
          "[&_.rt-TableCell]:!shadow-none",
          "[&_.rt-TableBody_.rt-TableRow:not(:last-child)]:border-b",
          "[&_.rt-TableBody_.rt-TableRow:not(:last-child)]:border-[#F2F4F7]",
          "[&_.rt-TableHeader_.rt-TableColumnHeaderCell]:text-[#002652]",

          showLastDivider &&
            "[&_.rt-TableBody_.rt-TableRow:last-child]:border-b",
          showLastDivider &&
            "[&_.rt-TableBody_.rt-TableRow:last-child]:border-[var(--tbl-last-divider)]",

          "[&_.rt-TableHeader_.rt-TableColumnHeaderCell]:font-semibold",
          "[&_.rt-TableHeader_.rt-TableColumnHeaderCell]:text-[14px]",
          zebra && "[&_tbody_tr:nth-child(even)]:bg-orange-100",

          className
        )}
        {...props}
      >
        <Table.Header
          className={clsx(
            "h-[44px]",
            `bg-[${bgHeader}]`,
            showFirstDivider && "border-b-1 border-b-[#F2F4F7]"
          )}
        >
          <Table.Row>{headerCells}</Table.Row>
        </Table.Header>

        <Table.Body className="">{bodyRows}</Table.Body>
      </Table.Root>
    </Box>
  );
}
